<template>
  <div>
    <!--<b-button size="sm" @click="toggle_alert()">
      SHOW
    </b-button>-->
    <b-alert
      v-model="show_alert"
      class="position-fixed fixed-top m-2 rounded-0 toast-alert"
      :variant="variant"
      dismissible
    >
      {{ this.text }}
    </b-alert>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      show_alert: false,
      text: '',
      timer: 15000,
      variant: 'warning',
    };
  },
  methods: {
    handle_notification(data) {
      if (data.text) this.text = data.text;
      if (data.timer) this.timer = data.timer;
      if (data.variant) this.variant = data.variant;
      this.toggle_alert();
    },
    toggle_alert() {
      this.show_alert = true;
      setTimeout(() => {
        this.show_alert = false;
      }, this.timer);
    },
  },
};
</script>

<style lang="scss">
.toast-alert {
  display: inline-block;
  left: auto !important;
  width: auto !important;
  right: 0;

  opacity: 1;
  animation: toast 500ms cubic-bezier(0.23, 0.82, 0.16, 1.46);
  animation-iteration-count: 1;
}

@keyframes toast {
  0% {
    opacity: 0;
    transform: translateY(-200px);
  }

  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}
</style>
